import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ColetaService } from 'src/services/coleta.service';
import { TipoColetaService } from 'src/services/tipo-coleta.service';
import * as moment from 'moment';
import { PermissoesService } from 'src/services/permissoes.service';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-coletor',
    templateUrl: './coletor.component.html',
    styleUrls: ['./coletor.component.scss'],
    standalone: false
})
export class ColetorComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  dropDownStatus: any[] = [
    { value: null, label: 'Selecione' },
    { value: 0, label: 'Ativo' },
    { value: 1, label: 'Inativo' },
    { value: 2, label: 'Cancelado' }
  ];
  dataTipo: any[] = [];
  displayModal: boolean = false;
  displayModalTipo: boolean = false;
  loading: boolean = false;
  form: FormGroup;
  formTipo: FormGroup;
  direitoVisualizarColetores: boolean = false;
  direitoInserirColetores: boolean = false;
  direitoEditarColetores: boolean = false;
  direitoExcluirColetores: boolean = false;
  direitoVisualizarTipos: boolean = false;
  direitoInserirTipos: boolean = false;
  direitoEditarTipos: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  @ViewChild('tableWrapperTipo', { static: false }) tableWrapperTipo: ElementRef;
  scrollHeight: string = '600px';
  scrollHeightTipo: string = '600px';

  /** Modal de exclusão quando há estações vinculadas: usuário deve digitar "Excluir coletor" */
  modalExcluirComEstacoes: boolean = false;
  coletorParaExcluir: any = null;
  estacoesRelacionadas: Array<{ id: number; nome: string }> = [];
  inputExcluirColetor: string = '';
  readonly textoConfirmacaoExclusao = 'Excluir coletor';

  constructor(
    protected _formBuilder: FormBuilder,
    protected _coletaService: ColetaService,
    protected _tipoColetaService: TipoColetaService,
    protected permissaoService: PermissoesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) { }
  ngOnInit(): void {
    this.direitoVisualizarColetores = this.permissaoService.can('coletores_visualizar');
    this.direitoInserirColetores = this.permissaoService.can('coletores_inserir');
    this.direitoEditarColetores = this.permissaoService.can('coletores_editar');
    this.direitoExcluirColetores = this.permissaoService.can('coletores_excluir');
    this.direitoVisualizarTipos = this.permissaoService.can('tipo_coletores_visualizar');
    this.direitoInserirTipos = this.permissaoService.can('tipo_coletores_inserir');
    this.direitoEditarTipos = this.permissaoService.can('tipo_coletores_editar');

    this.form = this._formBuilder.group({
      id: [null],
      descricao: [null],
      tipo_integracao: [null],
      frequencia_execucao: [null],
      role_name: [null],
      ultima_data_hora_leitura: [null],
      usuario_endpoint: [null],
      senha_endpoint: [null],
      tipo_coleta_id: [null],
      url_configuracao: [null],
      pasta_ftp: [null],
      status: [null]
    })
    this.formTipo = this._formBuilder.group({
      id: [null],
      descricao: [null],
    })
    this.index()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
    if (this.tableWrapperTipo && this.tableWrapperTipo.nativeElement) {
      const wrapperHeight = this.tableWrapperTipo.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeightTipo = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  index(){
this._coletaService.index().subscribe(json => {
  this.data = json || [];
  setTimeout(() => {
    this.calculateScrollHeight();
  }, 200);
})
this._tipoColetaService.index().subscribe(json => {
  this.dataTipo = json || [];
  setTimeout(() => {
    this.calculateScrollHeight();
  }, 200);
})
  }

  openNew(){
      this.form.reset()
      this.displayModal = true
  }
  openNewTipo(){
      this.formTipo.reset()
      this.displayModalTipo = true
  }

  edit(event){
    this._coletaService.show(event.id).subscribe(json => {
      const registro = { ...event, ...json };

      // Se tipo_coleta_id vier como número ou objeto diferente, precisa encontrar o objeto correto no dataTipo
      if (registro.tipo_coleta_id && this.dataTipo && this.dataTipo.length > 0) {
        // Se for um número, busca o objeto correspondente no array dataTipo
        if (typeof registro.tipo_coleta_id === 'number') {
          const tipoColeta = this.dataTipo.find(tipo => tipo.id === registro.tipo_coleta_id);
          if (tipoColeta) {
            registro.tipo_coleta_id = tipoColeta;
          }
        } else if (registro.tipo_coleta_id && typeof registro.tipo_coleta_id === 'object' && registro.tipo_coleta_id.id) {
          // Se já for um objeto mas não estiver no formato correto, busca no array para garantir que seja o mesmo objeto
          const tipoColeta = this.dataTipo.find(tipo => tipo.id === registro.tipo_coleta_id.id);
          if (tipoColeta) {
            registro.tipo_coleta_id = tipoColeta;
          }
        }
      }
      const tipoColetaId = this.extrairTipoColetaId(registro.tipo_coleta_id);
      if (tipoColetaId !== 2) {
        registro.url_configuracao = null;
        registro.pasta_ftp = null;
      }

      this.form.patchValue(registro)
      this.displayModal = true
    })

  }

  editTipo(event){
    this._tipoColetaService.show(event.id).subscribe(json => {
      this.formTipo.patchValue(json)
      this.displayModalTipo = true
    })
  }

  /** Normaliza valor de texto para envio: retorna string trimada ou null se vazio. */
  private normalizarTextoEnvio(val: any): string | null {
    if (val == null) return null
    const s = String(val).trim()
    return s !== '' ? s : null
  }

  save(){
    this.loading = true
    const tipoId = this.extrairTipoColetaId(this.form.get('tipo_coleta_id')?.value)
    const raw = this.form.getRawValue()
    let params = { ...raw }
    params.tipo_coleta_id = tipoId

    const ctrlUrl = this.form.get('url_configuracao')
    const ctrlPasta = this.form.get('pasta_ftp')
    const urlVal = ctrlUrl?.value ?? raw?.url_configuracao
    const pastaVal = ctrlPasta?.value ?? raw?.pasta_ftp

    console.log('Tipo ID: ', tipoId);

    if (tipoId === 2) {
      params.url_configuracao = this.normalizarTextoEnvio(urlVal)
      params.pasta_ftp = this.normalizarTextoEnvio(pastaVal)
      console.log('URL: ', params.url_configuracao);
      console.log('Pasta: ', params.pasta_ftp);
    } else {
      params.url_configuracao = null
      params.pasta_ftp = null
    }

    this._coletaService.save(params, params.id).subscribe(json => {
      this.loading = false
      this.index()
      this.displayModal = false
    }, err => {
      this.loading = false
    })

  }

  extrairTipoColetaId(tipoColeta: any): number | null {
    if (tipoColeta && typeof tipoColeta === 'object' && tipoColeta.id != null) {
      return tipoColeta.id;
    }

    if (typeof tipoColeta === 'number') {
      return tipoColeta;
    }

    return null;
  }

  isTipoColetaComHost(): boolean {
    return this.extrairTipoColetaId(this.form?.get('tipo_coleta_id')?.value) === 2;
  }

  saveTipo(){
    this.loading = true
    let params = this.formTipo.value
    this._tipoColetaService.save(params, params.id).subscribe(json => {
      this.loading = false
      this.index()
      this.displayModalTipo = false
    }, err => {
      this.loading = false
    })
  }

  /**
   * Antes de excluir, chama GET /api/configuracao-coleta/{id}/estacoes-relacionadas.
   * Se não houver estações: confirmação simples Sim/Não.
   * Se houver estações: abre modal onde o usuário deve digitar "Excluir coletor".
   */
  confirmarExclusao(coletor: any): void {
    this._coletaService.getEstacoesRelacionadas(coletor.id).subscribe({
      next: (res: any) => {
        const existe = res?.existe === true;
        const estacoes = res?.estacoes ?? [];
        const temEstacoes = Array.isArray(estacoes) && estacoes.length > 0;
        if (!existe || !temEstacoes) {
          this.confirmarExclusaoSimples(coletor);
        } else {
          this.coletorParaExcluir = coletor;
          this.estacoesRelacionadas = estacoes;
          this.inputExcluirColetor = '';
          this.modalExcluirComEstacoes = true;
        }
      },
      error: (err) => {
        const msg = err?.error?.message || 'Configuração de coleta não encontrada.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: msg,
        });
      },
    });
  }

  private confirmarExclusaoSimples(coletor: any): void {
    const descricao = coletor.descricao || `ID ${coletor.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir o coletor "${descricao}" (código ${coletor.id})?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.excluirColetor(coletor.id),
    });
  }

  fecharModalExcluirComEstacoes(): void {
    this.modalExcluirComEstacoes = false;
    this.coletorParaExcluir = null;
    this.estacoesRelacionadas = [];
    this.inputExcluirColetor = '';
  }

  executarExclusaoComEstacoes(): void {
    if (!this.coletorParaExcluir || this.inputExcluirColetor !== this.textoConfirmacaoExclusao) return;
    this.excluirColetor(this.coletorParaExcluir.id);
    this.fecharModalExcluirComEstacoes();
  }

  /**
   * Chama DELETE /api/configuracao-coleta/{id}. Resposta 204 sucesso, 404 não encontrado.
   */
  private excluirColetor(id: number): void {
    this._coletaService.destroy(id).subscribe({
      next: () => {
        this.data = this.data.filter((item: any) => item.id !== id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Coletor excluído com sucesso.',
        });
        setTimeout(() => this.calculateScrollHeight(), 200);
      },
      error: (err) => {
        const status = err?.status;
        const msg = err?.error?.message || 'Configuração de coleta não encontrada.';
        if (status === 404) {
          this.data = this.data.filter((item: any) => item.id !== id);
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: msg || 'Coletor não encontrado. Removido da lista.',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg || 'Não foi possível excluir o coletor.',
          });
        }
      },
    });
  }
}
